<template>
  <div class="game">
    <div class="box" v-show="!showLoading">
      <div class="item">
        <p>{{ $t('choose_entry.style') }}</p>
        <div>
          <span
            v-for="(item, index) in styleList"
            :key="'style-' + index"
            :class="{ active: selectedStyle === index }"
            @click="selectStyle(index)"
          >
            {{ $t(item) }}
          </span>
        </div>
      </div>
      <div class="item">
        <p>{{ $t('choose_entry.want') }}</p>
        <div>
          <span
            v-for="(item, index) in wantList"
            :key="'want-' + index"
            :class="{ active: selectedWant === index }"
            @click="selectWant(index)"
          >
            {{ $t(item) }}
          </span>
        </div>
      </div>
      <van-button
        class="button"
        round
        type="primary"
        @click="startJourney"
      >
        {{ $t('choose_entry.start') }}
      </van-button>
    </div>

    <!-- 加载动画 -->
    <div class="loading-container" v-show="showLoading">
      <!-- 心形线条动画 -->
      <div class="heart-lines" v-show="showHeart">
        <svg width="120" height="120" viewBox="0 0 120 120">
          <path
            class="heart-path"
            d="M 60 100 C 60 100, 20 70, 20 45 C 20 30, 30 20, 45 20 C 52 20, 58 24, 60 30 C 62 24, 68 20, 75 20 C 90 20, 100 30, 100 45 C 100 70, 60 100, 60 100 Z"
            fill="none"
            stroke="white"
            stroke-width="2"
          />
        </svg>
      </div>

      <!-- 气泡上浮动画 -->
      <div class="bubbles-container" v-show="showImage">
        <div
          v-for="bubble in bubbles"
          :key="bubble.id"
          class="bubble"
          :style="{
            left: bubble.left + '%',
            animationDuration: bubble.duration + 's',
            animationDelay: bubble.delay + 's',
            width: bubble.size + 'px',
            height: bubble.size + 'px'
          }"
        >
          <img :src="`/img/girl${bubble.girlNum}.png`" :alt="$t('choose_entry.girl_alt')" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      selectedStyle: 0, // 默认选中第一个
      selectedWant: 0, // 默认选中第一个
      showLoading: false, // 控制加载动画显示
      showHeart: false, // 控制心形动画显示
      showImage: false, // 控制图片显示
      bubbles: [], // 气泡数据数组
      styleList: [
        'choose_entry.styles.internet_celebrity',
        'choose_entry.styles.moderator',
        'choose_entry.styles.model',
        'choose_entry.styles.nurse',
        'choose_entry.styles.secretary',
        'choose_entry.styles.married_woman',
        'choose_entry.styles.student',
        'choose_entry.styles.pregnant_woman',
        'choose_entry.styles.mother_and_daughter',
        'choose_entry.styles.lolita'
      ],
      wantList: [
        'choose_entry.wants.trio',
        'choose_entry.wants.arm_relationship',
        'choose_entry.wants.spray',
        'choose_entry.wants.sm'
      ]
    };
  },
  methods: {
    selectStyle(index) {
      this.selectedStyle = index;
    },
    selectWant(index) {
      this.selectedWant = index;
    },
    // 生成随机气泡数据
    generateBubbles() {
      const bubbles = [];
      const bubbleCount = 5; // 生成5个气泡，对应 girl1-5

      // 预定义5个不同的横向区间，确保分布更加分散
      const positionRanges = [
        { min: 5, max: 20 },    // 左侧
        { min: 25, max: 40 },   // 中左
        { min: 42, max: 58 },   // 中间
        { min: 60, max: 72 },   // 中右
        { min: 75, max: 85 }    // 右侧
      ];

      // 打乱位置区间顺序，增加随机性
      const shuffledRanges = positionRanges.sort(() => Math.random() - 0.5);

      for (let i = 0; i < bubbleCount; i++) {
        const range = shuffledRanges[i];
        bubbles.push({
          id: i,
          girlNum: i + 1, // 依次使用 girl1-5
          left: range.min + Math.random() * (range.max - range.min), // 在各自区间内随机
          size: 100 + Math.random() * 40, // 随机大小 100-140px
          duration: 5, // 统一持续时间 5秒
          delay: i * 0.5 // 每个气泡延迟0.5秒，错落出现
        });
      }

      return bubbles;
    },
    startJourney() {
      // 显示加载动画
      this.showLoading = true;

      // 第一步：显示心形线条动画
      this.showHeart = true;

      // 1秒后显示气泡上浮效果
      setTimeout(() => {
        this.showHeart = false;
        this.bubbles = this.generateBubbles(); // 生成随机气泡
        this.showImage = true;
      }, 1000);

      // 气泡飘动过程中跳转到选妃页面
      setTimeout(() => {
        this.$router.push({ path: '/Choose' });
      }, 4000);
    }
  }
};
</script>

<style lang="less" scoped>
*,
:after,
:before {
  box-sizing: border-box;
}

.game {
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  background: linear-gradient(180deg, #ffc9e3 0%, #ffd5e8 50%, #ffe4f0 100%);
  padding: 2rem 0;
}

.box {
  width: 94%;
  background: #fff;
  border-radius: 2rem;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  margin: 0 auto;
  padding: 2.5rem 1.5rem;
}

.item {
  display: flex;
  align-items: flex-start;
  margin-bottom: 1.5rem;
}

.item p {
  color: #666;
  font-size: 0.875rem;
  font-weight: 500;
  min-width: 70px;
  margin: 0;
  padding: 0.5rem 0.5rem 0 0;
  text-align: left;
}

.item > div {
  flex: 1;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.item > div span {
  padding: 0.5rem 1rem;
  border-radius: 2rem;
  font-size: 0.75rem;
  color: #666;
  background: #f5f5f5;
  cursor: pointer;
  transition: all 0.3s;
  white-space: nowrap;
}

.item > div span.active {
  background: #6b71df;
  color: #fff;
}

.button {
  width: auto;
  min-width: 200px;
  height: 2.8rem;
  font-size: 0.875rem;
  margin-top: 1rem;
  background: linear-gradient(to right, #6b71df 0%, #7b80e8 100%) !important;
  border: 0 !important;
  color: white !important;
  border-radius: 2rem !important;
  padding: 0 2rem !important;
}

/* 加载动画容器 */
.loading-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

/* 心形线条动画 */
.heart-lines {
  animation: heartPulse 1s ease-in-out;
}

.heart-path {
  stroke-dasharray: 300;
  stroke-dashoffset: 300;
  animation: drawHeart 1s ease-in-out forwards;
}

@keyframes drawHeart {
  to {
    stroke-dashoffset: 0;
  }
}

@keyframes heartPulse {
  0%, 100% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.1);
    opacity: 0.8;
  }
}

/* 气泡容器 */
.bubbles-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  pointer-events: none;
}

/* 单个气泡 */
.bubble {
  position: absolute;
  bottom: 15%;
  overflow: visible;
  filter: drop-shadow(0 8px 20px rgba(255, 105, 180, 0.3));
  animation-name: floatUp;
  animation-timing-function: ease-out;
  animation-fill-mode: forwards;
  opacity: 0;
}

.bubble img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
}

/* 气泡上浮动画 - 先渐入，再慢慢往上飘 */
@keyframes floatUp {
  0% {
    bottom: 15%;
    opacity: 0;
    transform: translateX(0) scale(0.8) rotate(0deg);
  }
  15% {
    opacity: 1;
    transform: translateX(0) scale(1) rotate(0deg);
  }
  30% {
    transform: translateX(-10px) scale(1) rotate(-3deg);
  }
  50% {
    transform: translateX(10px) scale(1) rotate(3deg);
  }
  70% {
    transform: translateX(-8px) scale(1) rotate(-2deg);
  }
  85% {
    opacity: 0.9;
  }
  100% {
    bottom: 95%;
    opacity: 0;
    transform: translateX(5px) scale(1) rotate(2deg);
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
</style>
